import { useState, useCallback } from 'react'

export function useToast() {
  const [message, setMessage] = useState('')
  const [show, setShow] = useState(false)

  const showToast = useCallback((msg: string, duration = 3000) => {
    setMessage(msg)
    setShow(true)

    setTimeout(() => {
      setShow(false)
    }, duration)
  }, [])

  const hideToast = useCallback(() => {
    setShow(false)
  }, [])

  return { message, show, showToast, hideToast }
}
